import coverages from "@/store/coverages"
import http from "@/http"
import store from "store"
import userFacility from "@/store/userFacility"
import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        "coverages": coverages,
        "userFacility": userFacility
    },

    state: {
        permissions: store.get("permissions"),
        token: store.get("token"),
        user: store.get("user")
    },

    getters: {
        activeToken (state) {
            if (state.token && state.token.token) {
                return state.token.token
            } else {
                return null
            }
        },

        hasPermissions: (state) => (targets) => {
            if (state.permissions === null) {
                return false
            }

            return state.permissions.reduce((accumulator, current) => {
                return accumulator || targets.indexOf(current) !== -1
            }, false)
        }
    },

    mutations: {
        setAuth (state, data) {
            state.permissions = data.permissions
            state.token = { ...data.token }
            state.user = { ...data.user }

            store.set("permissions", state.permissions)
            store.set("token", state.token)
            store.set("user", state.user)
        },

        unsetAuth (state) {
            state.permissions = null
            state.token = null
            state.user = null

            store.remove("permissions")
            store.remove("token")
            store.remove("user")
        },

        setPermissions (state, data) {
            state.permissions = data
            store.set("permissions", state.permissions)
        },

        setToken (state, data) {
            state.token = { ...data }
            store.set("token", state.token)
        },

        setUser (state, data) {
            state.user = data
        }
    },

    actions: {
        attemptLogin ({ commit }, creds) {
            const params = new URLSearchParams()
            params.append("username", creds.username)
            params.append("password", creds.password)

            return http.post("/api/login", params).then(response => {
                if (!response.data.error) {
                    commit("setAuth", response.data)
                }

                // we must return the response so components can use it
                return response
            })
        },

        changePassword ({ commit }, data) {
            const params = new URLSearchParams()
            params.append("password", data)

            return http.post("/api/change-password", params).then(response => {
                if (!response.data.error) {
                    commit("setPermissions", response.data.permissions)
                    commit("setToken", response.data.token)
                }

                return response
            })
        },

        async logout ({ commit }) {
            commit("unsetAuth")

            await http.post("/api/logout")
        },

        updateProfile ({ commit }, data) {
            const params = new URLSearchParams()

            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    params.append(key, data[key])
                }
            }

            return http.post("/api/update-profile", params).then(response => {
                if (!response.data.error) {
                    commit("setUser", response.data)
                }

                return response
            })
        }
    }
})



// WEBPACK FOOTER //
// ./src/store.js